module.exports = __webpack_public_path__ + "img/map_4.adbe8f5c.png";